import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    // [] significa que aun no se consultaron los accesos: mientras tanto el
    // sistema se comporta como permisivo (igual que antes de la seguridad).
    accesos: [],
    roles: [],
    seguridadActiva: "N",
    exigeCredenciales: "N",
    // La filial del usuario: con 0 ve todas las sedes. Los filtros de filial
    // de las ventanas de navegacion solo ofrecen la suya.
    idFilial: 0,
    // Si el perfil ya se consulto: el hook no lo vuelve a pedir si no ha cambiado el usuario.
    perfilCargado: false,
    usuarioPerfil: "",
    // Token de autorizacion de una accion sensible (dura tres minutos).
    token: "",
    usuarioToken: "",
    expiraToken: "",
};

export const seguridadSlice = createSlice({
    name: "seguridad",
    initialState,
    reducers: {
        setAccesos: (state, action) => {
            state.accesos = action.payload || [];
        },
        setParametros: (state, action) => {
            const parametros = action.payload || {};

            state.seguridadActiva = parametros.SEGURIDAD_ACTIVA || "N";
            state.exigeCredenciales = parametros.SEGURIDAD_EXIGE_CREDENCIALES || "N";
        },
        setPerfil: (state, action) => {
            const perfil = action.payload || {};

            state.idFilial = perfil.idFilial || 0;
            state.roles = perfil.roles || [];
            state.perfilCargado = true;
            state.usuarioPerfil = (perfil.codigo || "").toLowerCase();
        },
        setToken: (state, action) => {
            const data = action.payload || {};

            state.token = data.token || "";
            state.usuarioToken = data.usuario || "";
            state.expiraToken = data.expira || "";
        },
        limpiarToken: (state) => {
            state.token = "";
            state.usuarioToken = "";
            state.expiraToken = "";
        },
        limpiarSeguridad: (state) => {
            state.accesos = [];
            state.roles = [];
            state.seguridadActiva = "N";
            state.exigeCredenciales = "N";
            state.idFilial = 0;
            state.perfilCargado = false;
            state.usuarioPerfil = "";
            state.token = "";
            state.usuarioToken = "";
            state.expiraToken = "";
        },
    },
});

export const { setAccesos, setParametros, setPerfil, setToken, limpiarToken, limpiarSeguridad } = seguridadSlice.actions;

export default seguridadSlice.reducer;
